import LoginForm from 'profile/login/forms/LoginForm';

const ReturningCustomer = () => (
  <div className="c7-account-login--returning-customer">
    <h4>Returning Customer</h4>
    <LoginForm
      redirectLink="/checkout/checkout"
      forgotPasswordLink="/checkout/forgot-password"
      magicLink="/checkout/magic-link"
    />
  </div>
);

export default ReturningCustomer;
